import { API_BASE } from "@/lib/api";

/**
 * AI Coach transport.
 *
 * The backend keeps the /chat/stream URL for compatibility,
 * but returns a normal JSON response instead of SSE streaming.
 */
export async function streamChat({ message, onDelta, onError }) {
  try {
    const response = await fetch(`${API_BASE}/chat/stream`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      body: JSON.stringify({ message }),
    });

    let body = null;

    try {
      body = await response.json();
    } catch {
      body = null;
    }

    if (!response.ok) {
      const detail =
        body?.detail ||
        body?.message ||
        `HTTP ${response.status}`;

      const error = new Error(detail);

      error.status = response.status;

      error.response = {
        status: response.status,
        data: body,
      };

      onError?.(error);
      return;
    }

    if (body?.answer) {
      onDelta?.(body.answer);
    }
  } catch (error) {
    onError?.(error);
  }
}
